var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6C8.51088 6 6.60322 6.79018 5.1967 8.1967C3.79018 9.60322 3 11.5109 3 13.5V34.5C3 36.4891 3.79018 38.3968 5.1967 39.8033C6.60322 41.2098 8.51088 42 10.5 42H24C24.3978 42 24.7794 41.842 25.0607 41.5607C25.342 41.2794 25.5 40.8978 25.5 40.5C25.5 40.1022 25.342 39.7206 25.0607 39.4393C24.7794 39.158 24.3978 39 24 39H10.5C9.30653 39 8.16193 38.5259 7.31802 37.682C6.47411 36.8381 6 35.6935 6 34.5V18H42V25.5C42 25.8978 42.158 26.2794 42.4393 26.5607C42.7206 26.842 43.1022 27 43.5 27C43.8978 27 44.2794 26.842 44.5607 26.5607C44.842 26.2794 45 25.8978 45 25.5V13.5C45 11.5109 44.2098 9.60322 42.8033 8.1967C41.3968 6.79018 39.4891 6 37.5 6H10.5ZM10.5 13.5C10.8978 13.5 11.2794 13.342 11.5607 13.0607C11.842 12.7794 12 12.3978 12 12C12 11.6022 11.842 11.2206 11.5607 10.9393C11.2794 10.658 10.8978 10.5 10.5 10.5C10.1022 10.5 9.72064 10.658 9.43934 10.9393C9.15804 11.2206 9 11.6022 9 12C9 12.3978 9.15804 12.7794 9.43934 13.0607C9.72064 13.342 10.1022 13.5 10.5 13.5ZM15 13.5C15.3978 13.5 15.7794 13.342 16.0607 13.0607C16.342 12.7794 16.5 12.3978 16.5 12C16.5 11.6022 16.342 11.2206 16.0607 10.9393C15.7794 10.658 15.3978 10.5 15 10.5C14.6022 10.5 14.2206 10.658 13.9393 10.9393C13.658 11.2206 13.5 11.6022 13.5 12C13.5 12.3978 13.658 12.7794 13.9393 13.0607C14.2206 13.342 14.6022 13.5 15 13.5ZM21 12C21 12.3978 20.842 12.7794 20.5607 13.0607C20.2794 13.342 19.8978 13.5 19.5 13.5C19.1022 13.5 18.7206 13.342 18.4393 13.0607C18.158 12.7794 18 12.3978 18 12C18 11.6022 18.158 11.2206 18.4393 10.9393C18.7206 10.658 19.1022 10.5 19.5 10.5C19.8978 10.5 20.2794 10.658 20.5607 10.9393C20.842 11.2206 21 11.6022 21 12Z",
    fill: "url(#paint0_linear_1_259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 30C37.1022 30 36.7206 30.158 36.4393 30.4393C36.158 30.7206 36 31.1022 36 31.5C36 31.8978 36.158 32.2794 36.4393 32.5607C36.7206 32.842 37.1022 33 37.5 33H40.38L36.9825 37.245L33.474 36.0765C33.2097 35.9886 32.9262 35.976 32.6552 36.0401C32.3842 36.1042 32.1364 36.2425 31.9395 36.4395L28.9395 39.4395C28.6663 39.7224 28.5151 40.1013 28.5185 40.4946C28.5219 40.8879 28.6797 41.2641 28.9578 41.5422C29.2359 41.8203 29.6121 41.9781 30.0054 41.9815C30.3987 41.9849 30.7776 41.8337 31.0605 41.5605L33.405 39.216L37.026 40.4235C37.3171 40.5205 37.6309 40.5259 37.9251 40.439C38.2193 40.3521 38.4798 40.1771 38.6715 39.9375L42 35.73V37.5C42 37.8978 42.158 38.2794 42.4393 38.5607C42.7206 38.842 43.1022 39 43.5 39C43.8978 39 44.2794 38.842 44.5607 38.5607C44.842 38.2794 45 37.8978 45 37.5V31.5C45 31.1022 44.842 30.7206 44.5607 30.4393C44.2794 30.158 43.8978 30 43.5 30H37.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_259",
    x1: 33.122,
    y1: 14.1133,
    x2: 17.0853,
    y2: 38.2275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490049,
    stopColor: "#FA7C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8CED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.3f71fd1011a6555e92bcb15ec6a29c60.svg";
export { ForwardRef as ReactComponent };